import axios from 'axios';

// A site laptop's API runs next to the front end, so opened from another computer (by the laptop's IP)
// "localhost" has to mean the laptop, not the computer the browser runs on
const baseURL = process.env.REACT_APP_API_BASEURL?.replace('//localhost', `//${window.location.hostname}`);

const instance = axios.create({
    baseURL,
    timeout: 500000
});

export default instance;
